import React from "react";
import PopUpIcon from "../../../commonComponents/formComponents/PopUpIcon";
import { useValidateNameAddressUsingEori } from "../../hooks/AGS/useValidateNameAddressUsingEori";
import { TranslateContext } from "../TranslateContext";

 const ActorDetailHeader = ({
    actorType,
    title,
    isExpanded,
    isImportShipment,
    isDMS
 }) => {
const {name,validationMsg}=useValidateNameAddressUsingEori(isImportShipment,isDMS,actorType)
console.log({validationMsg})

 const translate = React.useContext(TranslateContext).translate

    return (
       <div>
           {validationMsg && <PopUpIcon 
              style={{"display": "inline"}}
              color="red" icon="warning sign"
              popupText={validationMsg}
             />
           }
           {translate(title, {ns:["default", "parties", "header"]})}
           {!isExpanded && <strong>&nbsp;{name}</strong>}
      
       </div>
     );
  
}


export default React.memo(ActorDetailHeader)
